var map = {
	"./1.jpg": 207,
	"./10.jpg": 208,
	"./2.jpg": 209,
	"./3.jpg": 210,
	"./4.jpg": 211,
	"./5.jpg": 212,
	"./6.jpg": 213,
	"./7.jpg": 214,
	"./8.jpg": 215,
	"./9.jpg": 216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;